var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleQuestIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#FFC535"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.884 8.072V8.684H8.372V8.18C8.372 7.988 8.384 7.82 8.432 7.7C8.48 7.58 8.564 7.424 8.696 7.256L9.392 6.32C9.608 6.044 9.764 5.78 9.86 5.54C9.956 5.3 10.004 5.024 10.004 4.736C10.004 4.328 9.908 3.968 9.716 3.644C9.524 3.32 9.248 3.068 8.888 2.876C8.528 2.696 8.12 2.6 7.664 2.6C6.92 2.6 6.344 2.804 5.948 3.188C5.54 3.584 5.336 4.16 5.324 4.904H6.776C6.776 4.592 6.848 4.352 6.98 4.196C7.112 4.04 7.328 3.956 7.616 3.956C7.904 3.956 8.108 4.04 8.252 4.184C8.396 4.328 8.468 4.532 8.468 4.784C8.468 4.952 8.432 5.12 8.372 5.264C8.3 5.408 8.192 5.588 8.036 5.792L7.376 6.644C7.16 6.92 7.028 7.148 6.968 7.328C6.908 7.52 6.884 7.76 6.884 8.072ZM6.836 9.488V11H8.408V9.488H6.836Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuestIc);
export default __webpack_public_path__ + "static/media/circle_quest_ic.641dba7c37c9cabeec9df9062c825841.svg";
export { ForwardRef as ReactComponent };